import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Contact } from '../../interfaces/Contact';
import Content from '../Content';
import Section from '../../../../components/Section';

export interface OpeningHoursProps {
  contact: Contact;
}

const OpeningHours: FC<OpeningHoursProps> = ({ contact }) => {
  const { t } = useTranslation('ContactUsPage');
  const display = useMemo(
    () => contact && contact.openingHours && !contact.openingHours.every((o) => o === ''),
    [contact],
  );

  return (
    display ?
      <Section name={t('openingHours')}>
        <Content lines={contact.openingHours} />
      </Section>
      : null
  );
};

export default OpeningHours;
